<template>
    <div>
    <div class="container mt-4 mb-4">
        <!-- <atras-component></atras-component> -->
        <boton-atras :nombre_ruta="'estatal'"></boton-atras>
        <div class="row">
            <div class="col-md  mt-1 order-2 order-sm-2 order-md-1 order-lg-1">
                <h6 class="subtitulo mb-2">Convenios y otros</h6>
                <div class="lineaNegra"></div>
                <div class="mt-1 mb-2 lineaNegra2"></div>
                <!-- Angeda contable | Agenda contable 2021 
                <a :href="urlServe+'marco-juridico/Estatal/informacion/Otros/AC2021.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5> Agenda Contable - 2021</h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>-->
                <!-- Agenda contable 2022 
                <a :href="urlServe+'marco-juridico/Estatal/informacion/Otros/AC2022.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5> Agenda Contable - 2022 </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>-->
                <!-- Agenda contable 2023 
                <a :href="urlServe+'marco-juridico/Estatal/informacion/Otros/AC2023.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5> Agenda Contable - 2023 </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>-->
                <!-- Acuerdo1 con anexos -->
                <a :href="urlServe+'marco-juridico/Estatal/informacion/Convenios/Colaboracion-administrativa/ConvenioC.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5>Convenio de colaboración administrativa en materia fiscal federal que celebran el gobierno federal por conducto de la Secretaría de Hacienda y Crédito Público y el Gobierno del Estado de Chiapas </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>
                <!-- Anexos de este acuerdo -->
                <div class="accordion mt-2 mb-5" id="accordionExample">
                   <div class="card">
                        <div class="card-header" id="headingOne">
                            <h2 class="mb-0">
                                <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapse1" aria-expanded="true" aria-controls="collapseOne" style="display:flex; justify-content:space-between;">
                                    <span><p class="m-0">Anexos</p></span>
                                    <span class="descargar"><i class='bx bx-chevron-down icono-down'></i></span>
                                </button>
                            </h2>
                            <div id="collapse1" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                                <div class="card-body">
                                    <ul>
                                        <li><a :href="urlServe+'marco-juridico/Estatal/informacion/Convenios/Colaboracion-administrativa/Anexo1.pdf'" target="_blank">Anexo 1</a></li>
                                        <li><a :href="urlServe+'marco-juridico/Estatal/informacion/Convenios/Colaboracion-administrativa/Anexo2.pdf'" target="_blank">Anexo 2</a></li>
                                        <li><a :href="urlServe+'marco-juridico/Estatal/informacion/Convenios/Colaboracion-administrativa/Anexo3.pdf'" target="_blank">Anexo 3</a></li>
                                        <li><a :href="urlServe+'marco-juridico/Estatal/informacion/Convenios/Colaboracion-administrativa/Anexo4.pdf'" target="_blank">Anexo 4</a></li>
                                        <li><a :href="urlServe+'marco-juridico/Estatal/informacion/Convenios/Colaboracion-administrativa/Anexo5.pdf'" target="_blank">Anexo 5</a></li>
                                        <li><a :href="urlServe+'marco-juridico/Estatal/informacion/Convenios/Colaboracion-administrativa/Anexo6.pdf'" target="_blank">Anexo 6</a></li>
                                        <li><a :href="urlServe+'marco-juridico/Estatal/informacion/Convenios/Colaboracion-administrativa/Anexo7.pdf'" target="_blank">Anexo 7</a></li>
                                        <li><a :href="urlServe+'marco-juridico/Estatal/informacion/Convenios/Colaboracion-administrativa/Anexo8.pdf'" target="_blank">Anexo 8</a></li>
                                        <li><a :href="urlServe+'marco-juridico/Estatal/informacion/Convenios/Colaboracion-administrativa/Anexo9.pdf'" target="_blank">Anexo 9</a></li>
                                        <li><a :href="urlServe+'marco-juridico/Estatal/informacion/Convenios/Colaboracion-administrativa/Anexo10.pdf'" target="_blank">Anexo 10</a></li>
                                        <li><a :href="urlServe+'marco-juridico/Estatal/informacion/Convenios/Colaboracion-administrativa/Anexo11.pdf'" target="_blank">Anexo 11</a></li>
                                        <li><a :href="urlServe+'marco-juridico/Estatal/informacion/Convenios/Colaboracion-administrativa/Anexo12.pdf'" target="_blank">Anexo 12</a></li>
                                        <li><a :href="urlServe+'marco-juridico/Estatal/informacion/Convenios/Colaboracion-administrativa/Anexo13.pdf'" target="_blank">Anexo 13</a></li>
                                        <li><a :href="urlServe+'marco-juridico/Estatal/informacion/Convenios/Colaboracion-administrativa/Anexo14.pdf'" target="_blank">Anexo 14</a></li>
                                        <li><a :href="urlServe+'marco-juridico/Estatal/informacion/Convenios/Colaboracion-administrativa/Anexo15.pdf'" target="_blank">Anexo 15</a></li>
                                        <li><a :href="urlServe+'marco-juridico/Estatal/informacion/Convenios/Colaboracion-administrativa/Anexo16.pdf'" target="_blank">Anexo 16</a></li>
                                        <li><a :href="urlServe+'marco-juridico/Estatal/informacion/Convenios/Colaboracion-administrativa/Anexo17.pdf'" target="_blank">Anexo 17</a></li>
                                        <li><a :href="urlServe+'marco-juridico/Estatal/informacion/Convenios/Colaboracion-administrativa/Anexo18.pdf'" target="_blank">Anexo 18</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Acuerdo2 on anexos -->
                <a :href="urlServe+'marco-juridico/Estatal/informacion/Convenios/Adhesion/ConvenioA.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5>Convenio de adhesión al sistema nacional de coordinación fiscal que celebran la Secretaría de Hacienda y Crédito Público y el Gobierno del Estado de Chiapas </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>
                <!-- Anexos de este acuerdo -->
                <div class="accordion mt-2 mb-5" id="accordionExample">
                   <div class="card">
                        <div class="card-header" id="headingOne">
                            <h2 class="mb-0">
                                <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapse2" aria-expanded="true" aria-controls="collapseOne" style="display:flex; justify-content:space-between;">
                                    <span><p class="m-0">Anexos</p></span>
                                    <span class="descargar"><i class='bx bx-chevron-down icono-down'></i></span>
                                </button>
                            </h2>
                            <div id="collapse2" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                                <div class="card-body">
                                    <ul>
                                        <li><a :href="urlServe+'marco-juridico/Estatal/informacion/Convenios/Adhesion/Anexo1.pdf'" target="_blank">Anexo 1</a></li>
                                        <li><a :href="urlServe+'marco-juridico/Estatal/informacion/Convenios/Adhesion/Anexo2.pdf'" target="_blank">Anexo 2</a></li>
                                        <li><a :href="urlServe+'marco-juridico/Estatal/informacion/Convenios/Adhesion/Anexo3.pdf'" target="_blank">Anexo 3</a></li>
                                        <li><a :href="urlServe+'marco-juridico/Estatal/informacion/Convenios/Adhesion/Anexo4.pdf'" target="_blank">Anexo 4</a></li>
                                        <li><a :href="urlServe+'marco-juridico/Estatal/informacion/Convenios/Adhesion/Anexo5.pdf'" target="_blank">Anexo 5</a></li>
                                        <li><a :href="urlServe+'marco-juridico/Estatal/informacion/Convenios/Adhesion/Anexo6.pdf'" target="_blank">Anexo 6</a></li>
                                        <li><a :href="urlServe+'marco-juridico/Estatal/informacion/Convenios/Adhesion/Anexo7.pdf'" target="_blank">Anexo 7</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Acuerdos sueltos -->
                <a :href="urlServe+'marco-juridico/Estatal/informacion/Convenios/Adhesion/Peajes.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5> Convenio de Peajes y Regalías </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>
                 <a :href="urlServe+'marco-juridico/Estatal/informacion/Convenios/Adhesion/Metodologia.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5> Convenio para acordar la Metodología, fuente de Información y Mecanismo de Distribución del Fondo de Aportaciones para la Infraestructura Social Municipal </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>
                <a :href="urlServe+'marco-juridico/Estatal/informacion/Convenios/Adhesion/Simultaneidad.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5> Simultaneidad (Modificación al Convenio) </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>
                <a :href="urlServe+'marco-juridico/Estatal/informacion/Convenios/Adhesion/Incentivos.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5> Incentivos I.S.R. - IMPAC (Modificación al Convenio) </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>
                <a :href="urlServe+'marco-juridico/Estatal/informacion/Convenios/Adhesion/AcuerdoCoord..pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5> Acuerdo de Coordinación que celebran la Secretaría de la Función Pública y el Estado de Chiapas, cuyo objeto es la realización de un programa de coordinación especial denominado Fortalecimiento del Sistema Estatal de Control y Evaluación de la Gestión Pública, y Colaboración en Materia de Transparencia y Combate a la Corrupción. </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>
                <a :href="urlServe+'marco-juridico/Estatal/informacion/Convenios/Adhesion/ficha-valora-doc.docx'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5> Ficha Técnica de Valoración Documental</h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>
                <a :href="urlServe+'marco-juridico/Estatal/informacion/Convenios/Adhesion/CSD-ITAIPCHIS.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5> Catálogo de Secciones y Series Documentales</h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>
                <a :href="urlServe+'marco-juridico/Estatal/informacion/Convenios/Adhesion/SIA.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5> Acta de Instalación del Sistema Institucional de Archivos (SIA) </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>
                <a :href="urlServe+'marco-juridico/Estatal/informacion/Convenios/Adhesion/Minutaa.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5> Minuta de la última Sesión Ordinaria realizada por el Grupo Interdisciplinario en el presente año.</h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>
                <a :href="urlServe+'marco-juridico/Estatal/informacion/Convenios/Adhesion/PADA-21.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5> Informe anual del Plan de Desarrollo Archivístico 2021 (PADA) </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>
                <a :href="urlServe+'marco-juridico/Estatal/informacion/Convenios/Adhesion/PADA-23.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5> Informe anual del Plan de Desarrollo Archivístico 2023 (PADA) </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>
                <a :href="urlServe+'marco-juridico/Estatal/informacion/Convenios/Adhesion/PADA-24.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5> Informe anual del Plan de Desarrollo Archivístico 2024 (PADA) </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>
                <a :href="urlServe+'marco-juridico/Estatal/informacion/Convenios/Adhesion/PADA-25.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5> Informe anual del Plan de Desarrollo Archivístico 2025 (PADA) </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>

                <a :href="urlServe+'marco-juridico/Estatal/informacion/Otros/Depreciacion_proced.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5>Procedimiento de Depreciación </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>
                <a :href="urlServe+'marco-juridico/Estatal/informacion/Otros/Cuadro2018.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5>Cuadro Correlativo de la Normatividad Presupuestaria 2018 </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>
                <a :href="urlServe+'marco-juridico/Estatal/informacion/Otros/Plazos-Presupuestarios-2018.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5>Plazos Presupuestarios 2018 </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>
                <!-- ========!!!!CHECAR YA QUE ESTE ME REDIRIGIRA  AL LA NUEVA VISTA DE PERIODICOS OFICIALES=========== -->
                <a @click="emitir">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5> Periódicos Oficiales 2015-2004 </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Enlace <i class='bx bx-link icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>
                <!-- ============================ -->
                <a :href="urlServe+'marco-juridico/Estatal/informacion/Otros/Estratificacion.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5>Estratificación Poblacional </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>
                <a :href="urlServe+'marco-juridico/Estatal/informacion/Otros/Aplicacion.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5>Manual de Aplicación Metodológica Gestión por Resultados 2010 </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>
                <a :href="urlServe+'marco-juridico/Estatal/informacion/Otros/Operacion.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5>Manual de Operación Cualitativa del Presupuesto de Egresos 2010 en el SIAHE </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>
                <a :href="urlServe+'marco-juridico/Estatal/informacion/Otros/Formatos.zip'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5>Formatos de Adecuaciones Estructurales y de Plantilla de Plazas </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>
                <a :href="urlServe+'marco-juridico/Estatal/informacion/Otros/Manual_SIGHA_2026.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5>Manual Operativo del Sistema Integral de Gestión Hacendaria y Administrativa (SIGHA) 2026, Apartado Cualitativo </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>
                <a :href="urlServe+'marco-juridico/Estatal/informacion/Otros/Manual_SIGHA_2025.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5>Manual Operativo del Sistema Integral de Gestión Hacendaria y Administrativa (SIGHA) 2025, Apartado Cualitativo </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>
                <a :href="urlServe+'marco-juridico/Estatal/informacion/Otros/Manual_SAPE_2017.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5>Manual Operativo del Sistema de Anteproyecto de Presupuesto de Egresos SAPE 2017 </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>
                <a :href="urlServe+'marco-juridico/Estatal/informacion/Otros/Manual_SAPE_2016.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5>Manual Operativo del Sistema de Anteproyecto de Presupuesto de Egresos SAPE 2016 </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>
                <a :href="urlServe+'marco-juridico/Estatal/informacion/Otros/Manual_SIAHE_2020.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5>Manual Operativo del Sistema Integral de Administración Hacendaria Estatal (Apartado Cualitativo) SIAHE 2020</h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>
                <a :href="urlServe+'marco-juridico/Estatal/informacion/Otros/Manual_SIAHE_2019.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5>Manual Operativo del Sistema Integral de Administración Hacendaria Estatal (Apartado Cualitativo) SIAHE 2019 </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>
                <a :href="urlServe+'marco-juridico/Estatal/informacion/Otros/Manual_SIAHE_2018.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5>Manual Operativo del Sistema Integral de Administración Hacendaria Estatal (Apartado Cualitativo) SIAHE 2018 </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>
                <a :href="urlServe+'marco-juridico/Estatal/informacion/Otros/Manual_SIAHE_2017.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5>Manual Operativo del Sistema Integral de Administración Hacendaria Estatal (Apartado Cualitativo) SIAHE 2017 </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>
                <a :href="urlServe+'marco-juridico/Estatal/informacion/Otros/Manual_SIAHE_2016.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5>Manual Operativo del Sistema Integral de Administración Hacendaria Estatal (Apartado Cualitativo) SIAHE 2016 </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>
                <a :href="urlServe+'marco-juridico/Estatal/informacion/Otros/Manual_SIAHE_2015.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5>Manual Operativo del Sistema Integral de Administración Hacendaria Estatal (Apartado Cualitativo) SIAHE 2015 </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>
                <a :href="urlServe+'marco-juridico/Estatal/informacion/Otros/Manual_Siahe_2013.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5>Manual Operativo del Sistema Integral de Administración Hacendaria Estatal (Apartado Cualitativo) SIAHE 2013 </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>
                <a :href="urlServe+'marco-juridico/Estatal/informacion/Otros/Cuadro-Gral-Clasif-Archivistica.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5>Cuadro General de Clasificación Archivística</h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>
                <a :href="urlServe+'marco-juridico/Estatal/informacion/Otros/CADIDO-SH.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5>Catálogo de Disposición Documental</h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>
                <a :href="urlServe+'marco-juridico/Estatal/informacion/Otros/Acta-Archivos.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5>Acta de la Sesión de Instalación del Grupo Interdisciplinario en Materia de Archivos de la Secretaría de Hacienda</h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>
                <a :href="urlServe+'marco-juridico/Estatal/informacion/Otros/ROGI.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5>Reglas de Operación del Grupo Interdisciplinario en Materia de Archivos de la Secretaría de Hacienda del Estado de Chiapas</h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>
                <a :href="urlServe+'marco-juridico/Estatal/informacion/Otros/Reglas-ISH.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5>Reglas de carácter general para el pago del Impuesto Sobre Hospedaje</h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>
                <a :href="urlServe+'marco-juridico/Estatal/informacion/Otros/CONCENT_INVENT.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5>Inventario Documental</h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>
                <a :href="urlServe+'marco-juridico/Estatal/informacion/Otros/Doc-Seg-Datos-Perso.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5>Documento de Seguridad en Materia de Protección de Datos Personales (<i>Versión Pública</i>)</h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div>
                        </div>
                    </div>
                </a>


                <!-- <h4 class="subtitulo2 mt-5">Ley de ingresos del Estado de Chiapas</h4> -->







            </div>

            <div class="col-md order-1 order-sm-1 order-md-2 order-lg-2 ">
                <div class="row margenes">
                    <div class="sec_imagen">
                        <img src="@/assets/imagenes/programasInst.jpg" alt="">
                    </div>
                </div>
                <!--  -->
                <!--  -->
                <div class="row mt-4 row margenes tab-select">
                    <convenio-select></convenio-select>
                </div>

            </div>
        </div>
        <div class="text-aviso my-5">
                <h5> <span class="resaltado-vino">AVISO:</span> Los instrumentos jurídicos que se mencionan a continuación, son solo de referencia, encontrándose para su consulta oficial en el portal de internet de la <u><a href="https://www.sgg.chiapas.gob.mx/" target="_blank" class="resaltado-vino">Secretaría General de Gobierno</a></u>, o en su caso en la versión impresa en el órgano de difusión oficial.</h5>
        </div>
    </div>

    </div>
</template>

<script>
import atrasComponent from './../../reload.vue'
import botonAtras from './../../button-atras'
import convenioSelect from './convenios-select.vue';
export default {
    mounted(){
        window.scrollTo(0, 0);
    },
    data: function(){
        return {
            emitido: 'emitir__',
        }
    },
    components:{
        atrasComponent,
        convenioSelect,
        botonAtras
    },
    methods:{
        emitir(){
            console.log('asdasndja hola');
            this.$emit('emitido', this.emitido);
        }
    }
}
</script>

<style scoped>
    .card-header { background-color: #fff; }
    .btn-link{ color: #474444; }
    .btn:focus { box-shadow: none; }
    .btn-link:hover { text-decoration: none; }

    li{
    list-style:none;
    margin-bottom: 1rem;
    border-bottom: 1px dotted rgb(189, 182, 182);
    padding: .2rem;
    padding-left: 0 !important;
    font-size: 14px;
}
li a:hover{ color: #560f2c !important; text-decoration: none; }



    .title_document {
        padding: .8rem 1rem;
        width: 100%;
        height: auto;
        border: 1px solid#dfdfdf ;
        border-radius: 5px;
        border-left: 3px solid #621132;

        display: flex;
        justify-content: space-between;
        align-items: center !important;
    }

    .title_document:hover{
        box-shadow: 3px 8px 17px -13px rgba(0,0,0,0.75) !important;
    }

    .descargar{
        font-size: 0.9rem;
        color: #6c757d !important;
    }

    /*
    lo cambie a estilos.css
    .subtitulo {
        font-weight: 400;
        font-size: 1.8rem;
        margin-top: 1rem;
    } */
    /*

    .subtitulo2{
        font-weight: 400;
        font-size: 1.2rem;
        margin-top: .5rem;
        margin-bottom: 1rem ;
    } */
    .title_document h5{
        font-size: 0.9rem;
        font-weight: 400;
        /* line-height: 20px; */
    }

    .sec_imagen{
        width:85% !important;
        background-color: #560F2C;
        /* margin-top: 3rem; */
    }

    a{
        text-decoration: none !important;
        color: #212529;
    }
    a:hover{ color:#212529 !important; }

    /* margenes de la card consulta */
    .margenes{
        display: flex;
        justify-content: flex-end;
    }
    .card-width{ width: 90%; }

    /* select */
    .form-control-lg {
        font-size: 1rem;
        border-radius: .4rem;
    }

    .tab-select{
        position: sticky !important;
        top: 15% !important;
        z-index: 1000 !important;
    }

@media only screen and (max-device-width : 900px) {
    .container{
        padding-right: 1% !important;
        padding-left: 1% !important;
    }
    .title_document{
        padding: .5rem 1rem .5rem .1rem;
        line-height: 20px;
    }

    /* margenes de la card consulta */
    .margenes{ justify-content: space-around; }
    .card-width{ width: 95%; }

    .subtitulo2{ font-size: 1rem; }

    .sec_imagen{ margin-top: 0rem; }


    .tab-select{
        position: initial;
        z-index: auto;
    }
}

</style>
